export default "__VITE_ASSET__940f9640__"